import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {NgbActiveModal, NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Order} from '../../../classes/Order';
import {VisitorsService} from '../../../services/visitors.service';
import {Visitor} from '../../../classes/Visitor';
import {Office} from '../../../classes/Office';
import {OfficeService} from '../../../services/office.service';
import {Room} from '../../../classes/Room';
import {RoomService} from '../../../services/room.service';
import * as moment from 'moment';
import {VisitorAdminBookingOption} from '../../../enums/VisitorAdminBookingOption';

@Component({
  selector: 'app-visitors-edit',
  templateUrl: './visitors-edit.component.html',
  styleUrls: ['./visitors-edit.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VisitorsEditComponent implements OnInit {

  @Input() order: Order;
  @Input() id: number;
  @Input() showAdminFields = false;
  @Input() adminVisitor = false;
  public visitorForm: FormGroup;
  public errorMessage: string;
  public offices: Office[];
  public rooms: Room[];
  public bookingOptions = [];
  public minDate: NgbDateStruct;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private visitorsService: VisitorsService,
              private officeService: OfficeService,
              private roomService: RoomService,
              private calendar: NgbCalendar) {}

  ngOnInit(): void {
    this.initializeForm();
    this.bookingOptions = Object.keys(VisitorAdminBookingOption);
    this.minDate = this.calendar.getToday();

    // this.officeService.getAll().subscribe({
    //   next: (response: Office[]) => this.offices = response,
    //   error: err => console.log(err.error) // TODO handle error
    // });

    this.officeService.getAll().subscribe({
      next: (response: Office[]) => {
        const allowedCities = ['Sderot Hanasi 127', 'Pinsker 11'];
        this.offices = response.filter(office => allowedCities.includes(office.address));
      },
      error: err => console.log(err.error)
    });

    // this.roomService.getAll().subscribe({
    //   next: (response: Room[]) => this.rooms = response,
    //   error: err => console.log(err.error) // TODO handle error
    // });

    this.roomService.getAll().subscribe({
      next: (response: Room[]) => {
        const allowedRoomNames = ['Co-Working space', 'Co-Work space'];
        this.rooms = response.filter(room => allowedRoomNames.includes(room.name));
      },
      error: err => console.log(err.error)
    });
  }

  private initializeForm(): void {
    this.visitorForm = this.formBuilder.group({
      firstname: [this.order?.user?.firstname || '', Validators.required],
      lastname: [this.order?.user?.lastname || '', Validators.required],
      phone: [this.order?.user?.phone || '', Validators.required],
      email: [this.order?.user?.email || '', [Validators.required, Validators.email]],
      // officeId: [null, !Validators.required],
      // roomId: [null, !Validators.required],
      // bookingOption: ['', !Validators.required],
      // expirationDate: [null, !Validators.required]
      officeId: [null, this.showAdminFields ? Validators.required : Validators.nullValidator],
      roomId: [null, this.showAdminFields ? Validators.required : Validators.nullValidator],
      bookingOption: ['', this.showAdminFields ? Validators.required : Validators.nullValidator],
      expirationDate: [null, this.showAdminFields ? Validators.required : Validators.nullValidator]
    });
  }

  saveVisitor(): void {
    console.log('DDDDD');
    if (this.visitorForm?.valid) {
      console.log('UPDATE ' + this.order.user);
      const visitor: Visitor = {
        ...this.visitorForm.value,
        order: this.order,
        user: this.order.user,
        expirationDate: this.visitorForm.value.expirationDate ? this.convertToInstant(this.visitorForm.value.expirationDate) : null,
        adminVisitor: this.adminVisitor,
        id: this.id,
      };

      this.visitorsService.addOrEdit(visitor).subscribe(
        () => this.activeModal.close(visitor),
        (error) => this.errorMessage = error.error.message
      );
    }
  }

  closeModal(reason: string): void {
    this.activeModal.dismiss(reason);
  }

  convertDate(date: Date): NgbDateStruct {
    return date ? {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    } : null;
  }

  private convertToInstant(dateStruct: NgbDateStruct): string {
    const date = new Date(dateStruct.year, dateStruct.month - 1, dateStruct.day);
    return moment(date).toISOString();
  }
}
